<sepidz-review class="review">
  <div review-filters class="filters">
    <div class="listbox">
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('Branch')">
          <span>{{ "ClientApp.BackOffice.INV.InventoryReview.Branch" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'Branch'"></i>
        </div>
        <div *ngIf="selected === 'Branch'">
          <sepidz-remote-select-review
            [title]="'ClientApp.BackOffice.INV.InventoryReview.Branch' | translate"
            [form]="formGroup"
            name="Branch"
            key="BranchIds"
            apiName="Branch/ReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('WarehouseTitle')">
          <span>{{ "ClientApp.BackOffice.INV.PurchaseInvoiceReport.Warehouse" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'WarehouseTitle'"></i>
        </div>
        <div *ngIf="selected === 'WarehouseTitle'">
          <sepidz-remote-select-review
            [title]="'ClientApp.BackOffice.INV.PurchaseInvoiceReport.Warehouse' | translate"
            [form]="formGroup"
            name="Warehouse"
            key="WarehouseIds"
            apiName="Warehouse/WarehouseReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('DetailLedgerTitle')">
          <span>{{ "ClientApp.BackOffice.INV.PurchaseInvoiceReport.Supplier" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'DetailLedgerTitle'"></i>
        </div>
        <div *ngIf="selected === 'DetailLedgerTitle'">
          <sepidz-remote-select-review
            [title]="'ClientApp.BackOffice.INV.PurchaseInvoiceReport.Supplier' | translate"
            [form]="formGroup"
            name="DetailLedger"
            key="DetailLedgerIds"
            apiName="DetailLedger/GetPagining">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('InvVoucherKind')">
          <span>{{ "ClientApp.BackOffice.INV.PurchaseInvoiceReport.ReferenceVoucherKind" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'InvVoucherKind'"></i>
        </div>
        <div *ngIf="selected === 'InvVoucherKind'">
          <sepidz-remote-select-review
            [title]="'ClientApp.BackOffice.INV.PurchaseInvoiceReport.ReferenceVoucherKind' | translate"
            [form]="formGroup"
            name="InvVoucherKind"
            key="InvVoucherKindIds"
            apiName="InvVoucherKind/ReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
    </div>
  </div>
  <div review-content>
    <ssg-tabset class="tabset" (tabChange)="selectTab($event)">
      <ssg-tab
        *hasPermission="['Inventory:PurchaseInvoiceReview/GetPurchaseInvoice', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.INV.InventoryReview.PurchaseInvoiceReport' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.INV.InventoryReview.PurchaseInvoiceReport' | translate)"
          name="PurchaseInvoiceReport"
          [title]="'ClientApp.BackOffice.INV.InventoryReview.PurchaseInvoiceReport' | translate"
          reportName="GetPurchaseInvoiceReport"
          pathPreFix="INV"
          apiName="PurchaseInvoiceReview/GetPurchaseInvoice"
          areaName="Inventory"
          [columns]="GetPurchaseInvoiceReport"
          [filtering]="false"
          pathPreFix="INV">
        </sepidz-grid-review>
      </ssg-tab>
    </ssg-tabset>
  </div>
</sepidz-review>
